import { create } from 'zustand'

const useStore = create((set) => ({
    title: "",
    setTitle: (val) => set(() => ({ title: val })),
    scale: 0,
    setScale: (val) => set(() => ({ scale: val })),
    scaleFull: 0,
    setScaleFull: (val) => set(() => ({ scaleFull: val })),
    previewScale: 1,
    setPreviewScale: (val) => set(() => ({ previewScale: val })),
    leftSelect: "Slides",
    setLeftSelect: (val) => set(() => ({ leftSelect: val })),
    isFullScreen: false,
    setIsFullScreen: (val) => set(() => ({ isFullScreen: val })),
    interSelect: null,
    setInterSelect: (val) => set(() => ({ interSelect: val })),
    fonts: [],
    setFonts: (val) => set((state) => ({ fonts: val })),
    files: [],
    setFiles: (val) => set((state) => ({ files: [...state.files, val], selectFiles: [] })),
    selectFiles: [],
    setSelectFiles: (val) => set((state) => ({ selectFiles: [val, ...state.selectFiles] })),
    showModal: false,
    setShowModal: (val) => set(() => ({ showModal: val })),
    select: 0,
    setSelect: (val) => set((state) => ({
        select: val === state?.select ? state?.select : val,
        selects: val === state?.select ? state?.selects : []
    })),
    setSelectPrev: () => set((state) => ({
        select: state.select !== 0 ? state.select - 1 : state.select
    })),
    setSelectNext: () => set((state) => ({
        select: state.select + 1 === state.slides.length ? state.select : state.select + 1
    })),
    future: [],
    past: [],
    undo: (val) => set((state) => ({
        select: state.slides.length > 1 ? state.slides.length - 2 : state.select,
        future: [state.slides, ...state.future],
        past: state.past.slice(0, -1),
        slides: val,
    })),
    redo: () => set((state) => ({
        past: [...state.past, state.slides],
        future: state.future.slice(1),
        slides: state.future[0],
    })),
    slides: [{ bgType: "Solid Color", background: "#ffffff", elements: [] }],
    setSlides: (val) => set(() => ({ slides: val })),
    addSlide: (id) => set((state) => ({
        // past: [...state.past, state.slides],
        // future: [],
        slides: [...state.slides, { _id: id, bgType: "Solid Color", background: "#ffffff", elements: [] }],
        select: state?.slides?.length,
        selects: []
    })),
    deleteSlide: (index) => set((state) => ({
        slides: state.slides.length === 1 ? [{ bgType: "Solid Color", background: "#ffffff", elements: [] }] : state.slides.filter((_, i) => i !== index)
    })),
    editSlide: (name, val) => set((state) => ({
        // past: [...state.past, state.slides],
        // future: [],
        slides: state.slides.map((item, index) => index === state.select ? { ...item, [name]: val } : item)
    })),
    addElements: (val) => set((state) => ({
        // past: [...state.past, state.slides],
        // future: [],
        slides: state.slides.map((item, index) => index === state.select ? { ...item, elements: [...item?.elements, val] } : item),
        selects: [val?.id],
        leftSelect: val?.type === 'MCQ' || val?.type === 'QR' || val?.type === 'Word Cloud' || val?.type === 'Q&A' ? "Edit" : state?.leftSelect
    })),
    editElements: (name, val, id) => set((state) => ({
        // past: [...state.past, state.slides],
        // future: [],
        slides: state.slides.map((item, index) => index === state.select ? { ...item, elements: item?.elements?.map((itm, ind) => itm.id === id ? { ...itm, [name]: val } : itm) } : item)
    })),
    editElement: (name, val, id) => set((state) => ({
        slides: state.slides.map((item, index) => index === state.select ? { ...item, elements: item?.elements?.map((itm, ind) => itm.id === id ? { ...itm, [name]: val } : itm) } : item)
    })),
    deleteElements: (val) => set((state) => ({
        // past: [...state.past, state.slides],
        // future: [],
        slides: state.slides.map((item, index) => index === state.select ? { ...item, elements: item?.elements?.filter((e) => !state.selects.includes(e?.id)) } : item),
        selects: []
    })),
    deleteElement: (val) => set((state) => ({
        // past: [...state.past, state.slides],
        // future: [],
        slides: state.slides.map((item, index) => index === state.select ? { ...item, elements: item?.elements?.filter((e) => val !== e?.id) } : item),
        selects: []
    })),
    clickedPosition: { x: -1, y: -1 },
    setClickedPosition: (val) => set(() => ({ clickedPosition: val })),
    selects: [],
    addSelects: (val, multi) => set((state) => ({ selects: multi ? [...state?.selects, val] : [val] })),
    addSelect: (val) => set(() => ({ selects: val })),
    removeAllSelects: () => set(() => ({ selects: [] })),
    dragging: false,
    setDragging: (val) => set(() => ({ dragging: val })),
    editing: false,
    setEditing: (val) => set(() => ({ editing: val })),
    resizing: false,
    setResizing: (val) => set(() => ({ resizing: val })),
    guide: null,
    setGuide: (val) => set(() => ({ guide: val })),
}))

export default useStore;